/**
 *
 * @param {Blob} blob
 * @param {string} filename
 * @param {string} type
 */
export function downloadBlob(blob, filename, type = "") {
  let url = "";

  if (type)
    blob = new Blob([blob], {
      type,
    });

  url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.setAttribute("download", filename);
  link.click();
  window.URL.revokeObjectURL(url);
}



// WEBPACK FOOTER //
// ./src/common/helpers/file.js